import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const page_path = location.pathname + location.search;

    // Google Analytics 4 (gtag)
    if (window.gtag) {
      window.gtag("event", "page_view", { page_path });
    }

    // Meta Pixel
    if (window.fbq) {
      window.fbq("track", "PageView");
    }

    // Statcounter page tracking
    if (typeof window.sc_counter !== 'undefined') {
      try {
        window.sc_counter();
      } catch (e) {
        console.log('Statcounter tracking error:', e);
      }
    }
  }, [location]);

  return null;
}
